;(function () {
  window.initGroupMembershipsIndex = function (scope) {
    $(".client .subgroup input:not(.button)").each(function (_, el) {
      return $(el).change(function (event) {
        var group_id, path, user_id
        group_id = event.target.value
        user_id = $(el)
          .closest(".client")
          .find("#group_memberships_user_id")
          .val()
        path =
          "/users/" + user_id + "/group_memberships/" + group_id + "?subgroups"
        if (group_id === void 0 || user_id === void 0) {
          return
        }
        return $.get(path, function (resp) {
          var newEl
          newEl = $(resp)
          $(".subgroups").replaceWith(newEl)
          initSUI(newEl)
          return initPage(newEl)
        })
      })
    })
    return $(".client form").each(function (_, form) {
      return $(form).submit(function (event) {
        var container, group_id, idField, url, user_id
        container = $(form)
        idField = "." + container.find(".subgroups").data("id-from") + " input"
        group_id = container.find(idField).val()
        user_id = container.find("#group_memberships_user_id").val()
        url = "users/" + user_id + "/group_memberships/" + group_id
        $("form").attr("href", url)
        return form.submit()
      })
    })
  }
}).call(this)
